import { isHarmony, vc } from "@kd/env";

export const GTE_629 = +vc >= 975;
export const GTE_651 = +vc > 1180;

// 是否为全功能版本（只屏蔽鸿蒙629之前版本）
export const isFullFunctionality = !isHarmony || GTE_629;
